var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.248,
    height: 16.456,
    viewBox: "0 0 16.248 16.456",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "download",
    transform: "translate(1376.028 -875.949)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34514",
    "data-name": "Path 34514",
    d: "M-1360.78,885.657a1,1,0,0,0-1,1v3.165a.584.584,0,0,1-.583.583h-11.082a.584.584,0,0,1-.583-.583v-3.165a1,1,0,0,0-1-1,1,1,0,0,0-1,1v3.165a2.586,2.586,0,0,0,2.583,2.583h11.082a2.587,2.587,0,0,0,2.583-2.583v-3.165A1,1,0,0,0-1360.78,885.657Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34515",
    "data-name": "Path 34515",
    d: "M-1368.468,887.364a1,1,0,0,0,.707.293,1,1,0,0,0,.707-.293l3.958-3.958a1,1,0,0,0,0-1.414,1,1,0,0,0-1.414,0l-2.091,2.09v-7.133a1,1,0,0,0-1-1,1,1,0,0,0-1,1V884.4l-2.411-2.411a1,1,0,0,0-1.414,0,1,1,0,0,0,0,1.414Z",
    fill: "currentColor"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.4d79e192d6b1a920871d723ee2c49480.svg";
export { ForwardRef as ReactComponent };